import styled from 'styled-components';
import {theme} from '@styles/theme';

export const IconWithBackgroundWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  border-radius: 56px;
  background-color: ${theme.colors.accent02};
`;

export const IconWithBackgroundSecondWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border: 4px solid ${theme.colors.basic08};
  border-radius: 40px;
  background-color: ${theme.colors.accent02};
`;

export const IconWithBackgroundSuccessWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  border: 4px solid ${theme.colors.basic08};
  background-color: ${theme.colors.signalGreen01};
`;
